var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" }, [
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-10 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
        },
        [
          _c(
            "md-button",
            {
              staticClass: "md-fab",
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_c("md-icon", [_vm._v("arrow_back")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-80 md-medium-size-80 md-small-size-80 md-xsmall-size-100"
        },
        [
          _c(
            "md-card",
            { staticClass: "md-alignment-top-center md-elevation-1" },
            [
              _c("md-card-header", [
                _c("div", { staticClass: "md-title md-accent" }, [
                  _c("h2", [_vm._v("Finden Sie passende KI-Trainer")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "md-card-content",
                [
                  _vm._l(_vm.selectedsectors, function(sector) {
                    return _c(
                      "md-chip",
                      {
                        key: sector,
                        staticClass: "md-primary dist",
                        attrs: { "md-deletable": "" },
                        on: {
                          "md-delete": function($event) {
                            return _vm.removeSector(sector)
                          }
                        }
                      },
                      [_vm._v(_vm._s(sector))]
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.selectedskills, function(skill) {
                    return _c(
                      "md-chip",
                      {
                        key: skill,
                        staticClass: "md-accent dist",
                        attrs: { "md-deletable": "" },
                        on: {
                          "md-delete": function($event) {
                            return _vm.removeSkill(skill)
                          }
                        }
                      },
                      [_vm._v(_vm._s(skill))]
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.selectedcenters, function(center) {
                    return _c(
                      "md-chip",
                      {
                        key: center,
                        staticClass: "md-primary dist",
                        attrs: { "md-deletable": "" },
                        on: {
                          "md-delete": function($event) {
                            return _vm.removeCenter(center)
                          }
                        }
                      },
                      [_vm._v(_vm._s(center))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.range != "" && _vm.plz.length == 5
                    ? _c(
                        "md-chip",
                        {
                          staticClass: "md-accent dist",
                          attrs: { "md-deletable": "" },
                          on: {
                            "md-delete": function($event) {
                              _vm.range = ""
                              _vm.plz = null
                            }
                          }
                        },
                        [
                          _vm._v(
                            "Umkreis von " +
                              _vm._s(_vm.range) +
                              "km von " +
                              _vm._s(_vm.plz)
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "div",
                        { staticClass: "md-layout-item" },
                        [
                          _c(
                            "md-field",
                            [
                              _c("label", { attrs: { for: "sector" } }, [
                                _vm._v("Branchen")
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-select",
                                {
                                  attrs: {
                                    name: "sector",
                                    id: "sector",
                                    "md-dense": "",
                                    multiple: ""
                                  },
                                  model: {
                                    value: _vm.selectedsectors,
                                    callback: function($$v) {
                                      _vm.selectedsectors = $$v
                                    },
                                    expression: "selectedsectors"
                                  }
                                },
                                _vm._l(_vm.sectors, function(sector) {
                                  return _c(
                                    "md-option",
                                    {
                                      key: sector.hash,
                                      attrs: { value: sector.name }
                                    },
                                    [_vm._v(_vm._s(sector.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "md-layout-item" },
                        [
                          _c(
                            "md-field",
                            [
                              _c("label", { attrs: { for: "skill" } }, [
                                _vm._v("Schwerpunkte")
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-select",
                                {
                                  attrs: {
                                    name: "skill",
                                    id: "skill",
                                    "md-dense": "",
                                    multiple: ""
                                  },
                                  model: {
                                    value: _vm.selectedskills,
                                    callback: function($$v) {
                                      _vm.selectedskills = $$v
                                    },
                                    expression: "selectedskills"
                                  }
                                },
                                _vm._l(_vm.skills, function(skill) {
                                  return _c(
                                    "md-option",
                                    {
                                      key: skill.hash,
                                      attrs: { value: skill.name }
                                    },
                                    [_vm._v(_vm._s(skill.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "md-layout-item" },
                        [
                          _c(
                            "md-field",
                            [
                              _c("label", { attrs: { for: "center" } }, [
                                _vm._v("Kompetenzzentren")
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-select",
                                {
                                  attrs: {
                                    name: "center",
                                    id: "center",
                                    multiple: "",
                                    "md-dense": ""
                                  },
                                  model: {
                                    value: _vm.selectedcenters,
                                    callback: function($$v) {
                                      _vm.selectedcenters = $$v
                                    },
                                    expression: "selectedcenters"
                                  }
                                },
                                _vm._l(_vm.centers, function(center) {
                                  return _c(
                                    "md-option",
                                    {
                                      key: center.full,
                                      attrs: { value: center.full }
                                    },
                                    [_vm._v(_vm._s(center.short))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "p",
                        {
                          staticClass: "dist",
                          staticStyle: { "padding-left": "20px" }
                        },
                        [_vm._v("Umkreissuche")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "div",
                        { staticClass: "md-layout-item" },
                        [
                          _c(
                            "md-field",
                            [
                              _c("label", [_vm._v("Postleitzahl")]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.plz,
                                  callback: function($$v) {
                                    _vm.plz = $$v
                                  },
                                  expression: "plz"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "md-layout-item" },
                        [
                          _c(
                            "md-field",
                            [
                              _c("label", { attrs: { for: "range" } }, [
                                _vm._v("Umkreis")
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-select",
                                {
                                  attrs: {
                                    name: "range",
                                    id: "range",
                                    "md-dense": ""
                                  },
                                  model: {
                                    value: _vm.range,
                                    callback: function($$v) {
                                      _vm.range = $$v
                                    },
                                    expression: "range"
                                  }
                                },
                                [
                                  _c("md-option", { attrs: { value: "50" } }, [
                                    _vm._v("50km")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-option", { attrs: { value: "100" } }, [
                                    _vm._v("100km")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-option", { attrs: { value: "200" } }, [
                                    _vm._v("200km")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-option", { attrs: { value: "300" } }, [
                                    _vm._v("300km")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "md-option",
                                    { attrs: { value: "1000" } },
                                    [_vm._v("Unbeschränkt")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout md-gutter md-alignment-top-right"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "md-layout-item" },
                          [
                            _c(
                              "md-button",
                              {
                                staticClass: "md-raised md-accent",
                                on: {
                                  click: function($event) {
                                    return _vm.resetFilters()
                                  }
                                }
                              },
                              [_vm._v("Zurücksetzen")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "md-layout-item" }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "md-layout-item md-alignment-top-right"
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "md-layout-item md-alignment-top-right"
                          },
                          [
                            _c(
                              "md-button",
                              {
                                staticClass: "md-raised md-primary",
                                on: {
                                  click: function($event) {
                                    return _vm.applyFilters()
                                  }
                                }
                              },
                              [_vm._v("Anwenden")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "div",
                {
                  staticClass: "loading",
                  staticStyle: { "margin-top": "50px" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout md-gutter md-alignment-center-center"
                    },
                    [
                      _c("md-progress-spinner", {
                        attrs: {
                          "md-diameter": 50,
                          "md-stroke": 5,
                          "md-mode": "indeterminate"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading && _vm.searchresults.length == 0
            ? _c("div", [_vm._m(0)])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.searchresults, function(item) {
            return _c(
              "div",
              { key: item.hash },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "no-link",
                    attrs: {
                      to: {
                        name: "KITrainerDetail",
                        params: { hash: item.hash }
                      }
                    }
                  },
                  [
                    _c(
                      "md-card",
                      {
                        staticClass:
                          "margin-twenty md-alignment-top-center md-elevation-1",
                        attrs: { "md-with-hover": "" }
                      },
                      [
                        _c(
                          "md-card-header",
                          { staticClass: "md-title" },
                          [
                            _c("md-card-header-text", [
                              _vm._v(_vm._s(item.name))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("md-card-content", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-layout md-gutter md-alignment-center-center"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-size-20 md-medium-size-20 md-small-size-100 md-xsmall-size-100"
                                },
                                [
                                  item.image != "undefined"
                                    ? _c("img", {
                                        attrs: {
                                          "item.image": "",
                                          src: "/static/uploads/" + item.image
                                        },
                                        on: {
                                          error: function($event) {
                                            return _vm.imageLoadingError(item)
                                          }
                                        }
                                      })
                                    : _c("img", {
                                        attrs: {
                                          src: "`/static/uploads/no-avatar.jpg`"
                                        }
                                      })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-size-80 md-medium-size-80 md-small-size-100 md-xsmall-size-100"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout md-gutter md-alignment-top-center",
                                      staticStyle: { "padding-bottom": "50px" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                        },
                                        [
                                          _c("b", [_vm._v("Schwerpunkte:")]),
                                          _vm._v(" "),
                                          _vm._l(item.main_emphases, function(
                                            skill
                                          ) {
                                            return _c(
                                              "span",
                                              { key: skill.hash },
                                              [
                                                _c(
                                                  "md-chip",
                                                  {
                                                    staticClass: "md-primary",
                                                    staticStyle: {
                                                      margin: "2px"
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(skill.name))]
                                                )
                                              ],
                                              1
                                            )
                                          })
                                        ],
                                        2
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout md-gutter md-alignment-top-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout-item md-size-50 md-medium-size-30 md-small-size-50 md-xsmall-size-100"
                                        },
                                        [
                                          _c("b", [
                                            _vm._v("Kompetenzzentrum:")
                                          ]),
                                          _vm._v(" "),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                item.competence_center
                                              )
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout-item md-size-50 md-medium-size-30 md-small-size-50 md-xsmall-size-100"
                                        },
                                        [
                                          _c("b", [_vm._v("Ort:")]),
                                          _vm._v(" "),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(item.city)
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-10 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "md-layout md-gutter md-alignment-center-center",
        staticStyle: { "margin-top": "10px" }
      },
      [_c("h3", [_vm._v("Keine passenden Ergebnisse gefunden")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-adc8f9de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adc8f9de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/kitrainersearch/query/KITrainerSearch.vue
// module id = null
// module chunks = 